import { LeaderboardData } from "lib/types/LeaderboardTypes";
import { asyncActionCreators } from "../../lib/util/ReduxUtils";
import { ScopeInfo } from "../../lib/types/MiscTypes";

import * as Api from "../../Api";
import { Competition } from "lib/types/Competition";

export const getGroupCompetitions = asyncActionCreators<
	ScopeInfo,
	{
		[key: string]: Competition;
	}
>("[REWARDS] GET_GRIOUP_COMPETITIONS", async (action, dispatch, getState) => {
	const { fleetId, group } = action.payload;

	if (!fleetId) {
		return {};
	}

	const result = await Api.fetchFleetCompetitions.submit({
		query: {
			group: group || undefined,
			includeCompleted: true,
			detailed: true,
			includeGlobal: true,
		},
		params: { fleetId },
	});

	return result.data;
});
